/*
  Delegação de evento no "document" em vez de buscar os botões só no
  DOMContentLoaded: o botão "Comprar Já" também aparece no quick-add
  drawer da página de categoria (mesmo id "ComprarJaCustom-{section.id}",
  vindo do mesmo snippet product-sale-box), e esse drawer é carregado via
  fetch/AJAX bem depois do DOMContentLoaded (ver assets/quick-add.js) —
  por isso o clique não funcionava lá. Com o listener no document, o
  botão funciona não importa quando (ou quantas vezes) ele for inserido
  na página, sem precisar reatribuir nada.
*/
document.addEventListener('click', function(event) {
  var btn = event.target.closest('[id^="ComprarJaCustom-"]');
  if (!btn) return;

  var form = btn.closest('form') || document.querySelector('form[action*="/cart/add"]');
  if (!form) return;

  var formData = new FormData(form);
  btn.disabled = true;
  btn.textContent = 'Adicionando...';

  fetch('/cart/add.js', {
    method: 'POST',
    body: formData,
    headers: { 'Accept': 'application/json' }
  })
  .then(function(res) {
    if (!res.ok) throw new Error('Erro ao adicionar ao carrinho');
    return res.json();
  })
  .then(function() {
    window.location.href = '/cart';
  })
  .catch(function(err) {
    console.error(err);
    btn.disabled = false;
    btn.textContent = 'Comprar Já';
    alert('Não foi possível adicionar o produto ao carrinho. Tente novamente.');
  });
});